import { useState } from 'react'
import Modal, { ModalHeader, ModalBody, ModalFooter } from './Modal'
import Button from './Button'

interface DeleteConfirmModalProps {
  open: boolean
  onClose: () => void
  onConfirm: () => Promise<void> | void
  title: string
  message: React.ReactNode
  confirmLabel?: string
}

export default function DeleteConfirmModal({ open, onClose, onConfirm, title, message, confirmLabel = 'Desativar' }: DeleteConfirmModalProps) {
  const [loading, setLoading] = useState(false)

  async function handleConfirm() {
    if (loading) return
    setLoading(true)
    try {
      await onConfirm()
    } finally { setLoading(false) }
  }

  return (
    <Modal open={open} onClose={onClose} size="sm">
      <ModalHeader onClose={onClose}>{title}</ModalHeader>
      <ModalBody>
        <div className="text-sm text-gray-600">{message}</div>
      </ModalBody>
      <ModalFooter>
        <Button variant="outline" onClick={onClose}>Cancelar</Button>
        <Button variant="danger" onClick={handleConfirm} loading={loading}>{confirmLabel}</Button>
      </ModalFooter>
    </Modal>
  )
}
